Vue.component('contact', {
        props: { recaptcha: String },
        data: function () {
            return {
                categories: [],
                selectedCategory: {
                    open: false,
                    selected: {
                        Title: '',
                    }
                },
                userData: {
                    company: '',
                    name: '',
                    email: '',
                    phone: '',
                    category: '',
                    message: ''
                },
                settings: {
                    sendingData: false,
                    submitted: false,
                    resultMessage: '',
                    succeeded: null
                },
                phrases: {
                    company: PhrasesService.shared.getPhrase('contactform_company'),
                    name: PhrasesService.shared.getPhrase('contactform_name'),
                    email: PhrasesService.shared.getPhrase('contactform_email'),
                    phone: PhrasesService.shared.getPhrase('contactform_phone'),
                    category: PhrasesService.shared.getPhrase('contactform_category'),
                    message: PhrasesService.shared.getPhrase('contactform_message'),
                    send: PhrasesService.shared.getPhrase('contactform_send'),
                    selectcategory: PhrasesService.shared.getPhrase('contactform_selectcategory'),
                },
            };
        },
        methods: {
            openDropdown() {
                this.selectedCategory.open = true;
            },
            closeDropDown() {
                this.selectedCategory.open = false;
            },
            selectCategory(item) {
                this.selectedCategory.open = false;
                this.selectedCategory.selected = item;
            },
            send() {
                var _this = this;
                if (_this.settings.sendingData) { return; }

                _this.settings.submitted = true;
                _this.settings.resultMessage = '';

                if (!_this.userData.company.length || !_this.userData.name.length
                    || !_this.userData.email.length || !_this.userData.phone.length
                    || !_this.userData.message.length) {
                    return;
                }
                _this.settings.sendingData = true;

                axios.post(window._data.contactApiUrl + 'send',
                    {
                        company: _this.userData.company,
                        name: _this.userData.name,
                        email: _this.userData.email,
                        phone: _this.userData.phone,
                        category: _this.selectedCategory.selected.Title,
                        message: _this.userData.message,
                        langabbr: window._data.languageAbbr
                    }).then(function (response) {
                        _this.settings.succeeded = response.data.succeeded;
                        _this.settings.resultMessage = response.data.message;
                        _this.settings.sendingData = false;
                    }).catch(function (e) {
                        _this.settings.sendingData = false;
                    }).finally(function (e) {
                        _this.settings.sendingData = false;
                    });
            }
        },
        mounted() {
            this.categories = window._data.categories;
        },
        created() {
            document.addEventListener('click', event => {
                if (this.$el.contains(event.target)) {
                    if (event.target.tagName == 'INPUT' || event.target.tagName == 'TEXTAREA') {
                        this.closeDropDown()
                    }
                    return
                }
                this.closeDropDown()
            })
        }
    ,
template: `
    <div class="contact-form">
        <div class="form" v-show="!settings.succeeded">
            <div class="form__group"
                 :class="{'has-error' : settings.submitted && !userData.company.length}">
                <label for="" class="form__label">{{phrases.company}}</label>
                <div class="form__content">
                    <input type="text" class="form__field" v-model="userData.company" />
                </div>
            </div>
            <div class="form__group"
                 :class="{'has-error' : settings.submitted && !userData.name.length}">
                <label for="" class="form__label">{{phrases.name}}</label>
                <div class="form__content">
                    <input type="text" class="form__field" v-model="userData.name" />
                </div>
            </div>
            <div class="form__group form__group--fw"
                 :class="{'has-error' : settings.submitted && !userData.email.length}">
                <label for="" class="form__label">{{phrases.email}}</label>
                <div class="form__content">
                    <input type="text" class="form__field" v-model="userData.email" />
                </div>
            </div>
            <div class="form__group"
                 :class="{'has-error' : settings.submitted && !userData.phone.length}">
                <label for="" class="form__label">{{phrases.phone}}</label>
                <div class="form__content">
                    <input type="text" class="form__field" v-model="userData.phone" />
                </div>
            </div>
            <div class="form__group">
                <label for="" class="form__label">{{phrases.category}}</label>
                <div class="form__content">
                    <div class="form__dropdown" :class="{'open' : selectedCategory.open}">
                        <a href="" class="form__dropdown-trigger dropdown" @click.prevent="openDropdown()">
                            <span class="form__dropdown-trigger-text" v-if="selectedCategory.selected.Title == '' || selectedCategory.selected.Title == null">{{phrases.selectcategory}}</span>
                            <span class="form__dropdown-trigger-text" v-if="selectedCategory.selected.Title != ''">{{selectedCategory.selected.Title}}</span>
                            <svg class="form__dropdown-trigger-icon">
                                <use xlink:href="~/m/i/icons.svg#symbol-arrow"></use>
                            </svg>
                        </a>
                        <div class="form__dropdown-results " :class="{'db' : selectedCategory.open}">
                            <div class="form__dropdown-results-content">
                                <a href="" class="form__dropdown-results-item" v-for="category in categories" @click.prevent="selectCategory(category)">
                                    <span class="form__dropdown-results-item-text">{{category.Title}}</span>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="form__group form__group--fw"
                 :class="{'has-error' : settings.submitted && !userData.message.length}">
                <label for="" class="form__label">{{phrases.message}}</label>
                <div class="form__content">
                    <textarea class="form__field form__field--textarea" v-model="userData.message"></textarea>
                </div>
            </div>
            <div class="form__group">
                <div class="form__content">
                    <a href="" class="button button--small button--primary "
                       @click.prevent="send()"
                       :class="{'loading' : settings.sendingData}">
                        <span class="button__text">{{phrases.send}}</span>
                        <svg class="button__icon button__icon--arrow">
                            <use xlink:href="~/m/i/icons.svg#symbol-arrow"></use>
                        </svg>
                        <div class="spinner"></div>
                    </a>
                </div>
            </div>
        </div>

        <div class="form-message form-message--success" v-if="settings.succeeded && settings.resultMessage.length">
            <div class="form-message__icon-wrap">
                <svg class="form-message__icon form-message__icon--check">
                    <use xlink:href="~/m/i/icons.svg#symbol-check"></use>
                </svg>
            </div>
            <p class="form-message__text">{{settings.resultMessage}}</p>
        </div>

        <div class="form-message form-message--error" v-if="!settings.succeeded && settings.resultMessage.length">
            <div class="form-message__icon-wrap">
                <svg class="form-message__icon form-message__icon--times">
                    <use xlink:href="~/m/i/icons.svg#symbol-times"></use>
                </svg>
            </div>
            <p class="form-message__text">{{settings.resultMessage}}</p>
        </div>

    </div>
`
});
class PhrasesService {
    constructor() {
        this.phrases = {};

        if (!window._data || !window._data.phrases) {
            return;
        }

        for (var i = 0; i < window._data.phrases.length; i++) {
            var phrase = window._data.phrases[i];
            this.phrases[phrase.T] = phrase.V;
        }
    }

    getPhrase(title) {
        if (!this.phrases[title]) {
            return title;
        }

        return this.phrases[title];
    }
}

PhrasesService.shared = new PhrasesService();
(function (target) {

    target._app = new Vue({
        el: "#vueapp"
    });
})(window);
Vue.component('svg-icon', {
        props: ['icon'],
        data: function () {
            return {
                baseUrl: window._data.baseUrl
            };
        },
        methods: {
            getIconUrl: function () {
                return this.baseUrl + 'm/i/icons.svg#' + this.icon;
            }
        },
        mounted() {
        }
    ,
template: `
    <svg v-once><use v-bind="{\'xlink:href\' : getIconUrl()}" /></svg>
`
});
svg4everybody();

(function() {

    document.querySelector('.burger').addEventListener('click', function(event) {
        event.preventDefault();
        event.stopPropagation();
        this.classList.toggle('open', true);
        this.closest('.header').nextElementSibling.classList.toggle('open', true);
        document.body.classList.toggle('noscroll', true);
        return false;
    });
    
    document.querySelector('.responsive-menu__close').addEventListener('click', function(event) {
        event.preventDefault();
        event.stopPropagation();
        closeResponsiveMenu();
        return false;
    });
    
    function closeResponsiveMenu() {
        document.querySelector('.responsive-menu').classList.toggle('open', false);
        document.querySelector('.burger').classList.toggle('open', false);
        document.body.classList.toggle('noscroll', false);
    }
    
    // Close the responsive menu when clicking outside of it
    document.addEventListener('click', function(event) {
        const responsiveMenu = document.querySelector('.responsive-menu');
        const responsiveMenuContent = document.querySelector('.responsive-menu__content');
        const burger = document.querySelector('.burger');
        
        if (responsiveMenu.classList.contains('open') &&
            !responsiveMenuContent.contains(event.target) &&
            !burger.contains(event.target)) {
            closeResponsiveMenu();
        }
    });

    $('.js-trigger').on('click', function () {
        var _trigger = $(this);
        var _results = $(this).siblings('.js-results');
        _trigger.parent().toggleClass('open');
        _results.stop().slideToggle('fast');
        $('.js-trigger').not(_trigger).parent().removeClass('open');
        $('.js-results').not(_results).slideUp('fast');
        return false;
    });

    $('.js-accordion-trigger').on('click', function () {
        var _trigger = $(this);
        var _results = $(this).siblings('.js-accordion-results');
        _trigger.parent().toggleClass('open');
        _results.stop().slideToggle('fast');
        return false;
    });


})();